import {InjectionToken, Provider, Type} from '@angular/core';

/**
 * Optional configuration that lets a consuming project attach a help panel to the
 * user list. The library itself ships no help content and stays project-agnostic.
 */
export interface UserListHelpConfig {
  /**
   * Component rendered inside the help panel. Provided by the project so the
   * displayed content (e.g. the role descriptions) does not live in the library.
   */
  helpComponent: Type<unknown>;
}

/**
 * Token holding the user list help configuration. Not provided by default, so the
 * help action never appears unless a project opts in via {@link provideUserListHelp}.
 * Other projects are therefore unaffected.
 */
export const USER_LIST_HELP = new InjectionToken<UserListHelpConfig>('USER_LIST_HELP');

/**
 * Type-safe opt-in for the user list help panel. Add the returned provider to a
 * project's providers to enable the help action and supply the content component:
 *
 * `providers: [provideUserListHelp({helpComponent: MyRolesHelpComponent})]`
 */
export function provideUserListHelp(config: UserListHelpConfig): Provider {
  return {provide: USER_LIST_HELP, useValue: config};
}
